import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';

import { UploadStudyModalModule } from 'src/app/clinic-studies/upload-study-modal/upload-study-modal.module';
import { BackgroundFileUploaderComponent } from './background-file-uploader.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GroupByPipe } from '../../pipes/group-by.pipe';
import { SortByPipe } from '../../pipes/sort-by.pipe';
@NgModule({
  declarations: [BackgroundFileUploaderComponent, GroupByPipe, SortByPipe],
  imports: [CommonModule, RouterModule, UploadStudyModalModule, NgbTooltipModule, MatExpansionModule, BrowserAnimationsModule, MatProgressBarModule],
  exports: [BackgroundFileUploaderComponent, RouterModule, MatExpansionModule, MatProgressBarModule],
  providers: [CookieService],
})
export class BackgroundFileUploaderModule {}
